import React, { useRef } from 'react';
import { Box, Typography } from '@mui/material';
import moment from 'moment';
import { DraggerIcon, IconPencil, IconTrash } from '../../../../utils/icons';
import * as Reorder from '../../../../components/dnd/Reorder';
import { IProfession } from './constants';

interface Props {
  index: number;
  profession: IProfession;
  onEditProfession: (index: number) => void;
  onRemoveProfession: (index: number) => void;
}

export default function SingleProfessionEntry({
  index,
  profession,
  onEditProfession,
  onRemoveProfession,
}: Props) {
  const containerRef = useRef(null);

  const tenure = profession.startDate
    ? `${moment(profession.startDate).format('MM/YYYY')} – ${
        profession.isActive || !profession.endDate
          ? 'Present'
          : moment(profession.endDate).format('MM/YYYY')
      }`
    : '';

  // Sub-category and (optional) Area of Focus share the middle column.
  const subAndFocus = [profession.subProfession?.name, profession.subSubProfession?.name]
    .filter(Boolean)
    .join(' · ');

  return (
    <Box
      ref={containerRef}
      key={`profession-${index}`}
      className="flex gap-2 items-center justify-between p-3 sm:p-4 border border-border-token rounded-lg"
    >
      <Typography className="min-w-[fit-content]" fontFamily="CircularStdBlack">
        {profession.profession.name}
      </Typography>
      <Typography className="w-full text-text-2 text-center truncate">
        {subAndFocus}
      </Typography>
      {tenure && (
        <Typography
          className="text-text-2 whitespace-nowrap shrink-0"
          fontFamily="CircularStd"
        >
          {tenure}
        </Typography>
      )}
      {/* text-muted feeds the icons below via currentColor (SVG attrs can't take var()) */}
      <Box className="flex gap-2 items-center shrink-0 text-muted">
        <Box
          className="flex items-center justify-center cursor-pointer p-1"
          onClick={() => onEditProfession(index)}
        >
          <IconPencil size={18} stroke="currentColor" />
        </Box>
        <Box
          className="flex items-center justify-center cursor-pointer p-1"
          onClick={() => onRemoveProfession(index)}
        >
          <IconTrash width={18} height={18} stroke="currentColor" />
        </Box>
        <Reorder.Trigger index={index!} containerRef={containerRef}>
          <Box className="flex items-center justify-center cursor-pointer">
            <DraggerIcon size={26} stroke="currentColor" />
          </Box>
        </Reorder.Trigger>
      </Box>
    </Box>
  );
}
